<template>
    <div style="margin: 20px">
        <v-card class="mb-5">
            <v-toolbar dense color="primary" dark >
                <v-toolbar-title>Configurazione generale</v-toolbar-title>
            </v-toolbar>
            <v-container>
                <v-expansion-panels accordion>
                    <v-expansion-panel v-for="(target,i) in targets" :key="i" >
                        <v-expansion-panel-header>{{target.title}}</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-card>
                                <v-toolbar dense color="primary" dark align="center">
                                    <v-row>
                                        <v-col cols="5" align="left">
                                            <v-toolbar-title>{{target.title}}</v-toolbar-title>
                                        </v-col>
                                        <v-col cols="1">
                                            <v-btn small light @click="setGeneralData(target)">
                                                <v-icon color="success">mdi-floppy</v-icon>
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="1">
                                            <v-btn small light @click="addItem(target)">
                                                <v-icon color="primary">mdi-plus</v-icon>
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="5" align="right">
                                            <v-btn small light @click="getGeneralData([target])">
                                                <v-icon color="primary">mdi-autorenew</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-toolbar>
                                <v-container >                
                                    <v-data-table :headers="target.headers" :items="target.items" disable-pagination hide-default-footer >
                                        <template v-slot:item="{ item }" >
                                            <tr>
                                                <td v-for="(header, j) in target.headers" :key="j" style="padding:0 15px">
                                                    <template v-if="header.text!=null">
                                                        <v-text-field v-if="header.external==undefined" v-model="item[header.value]" :label="header.text" />                                                       
                                                        <v-select v-else :label="header.text" v-model="item[header.value]"  :items="getTargetItems(header.external.target)" :item-text="header.external.text" :item-value="header.external.value"/>
                                                    </template>                                                    
                                                </td>
                                                <td>
                                                    <v-btn small @click="item.validita=item.validita==1?0:1">
                                                        <v-icon :color="item.validita==1?'error':'success'">{{item.validita==1?'mdi-delete':'mdi-restore'}}</v-icon>
                                                    </v-btn>
                                                </td>
                                            </tr>
                                        </template>                
                                    </v-data-table>
                                </v-container>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>   
            </v-container>
        </v-card>             
    </div>
</template>
<script>
export default {
    name : 'ConfigurazioneGeneraleQuickConnext',
    data(){
        return{
            NETWORK : null,
            targets : [
                {
                    action:'__platforms', 
                    field_name:'piattaforme',
                    headers : [
                        { text:'Nome Piattaforma', value:'nome' },
                        { text: null, value : '_delete' }
                    ],
                    items : [],
                    primary_key:'id_piattaforma',
                    title:'Piattaforme'                    
                },
                {
                    action:'__inputtypes',
                    field_name:'tipi_input',
                        headers : [
                        { text:'Nome tipo input', value:'nome' },
                        { text:'Codice tipo input', value:'valore' },
                        { text: null, value : '_delete' }
                    ],
                    items : [],
                    primary_key:'id_tipo_input',
                    title:'Tipi input'                    
                },
                {
                    action:'__datatypes',
                    field_name:'tipi_dati',
                    headers : [
                        { text:'Nome tipo dato', value:'nome' },
                        { text:'ID dato QuickConnext', value:'id_dato_quickconnext' },
                        { text:'Tipo input', value:'id_tipo_input', external: { target:'tipi_input', text:'nome', value:'id_tipo_input' } },
                        { text: null, value : '_delete' }
                    ],
                    items : [],
                    primary_key:'id_tipo_dato',
                    title:'Tipi dati'
                }                
            ]
        }
    },
    mounted(){
        this.NETWORK = this.$store.state.Network;
        this.getGeneralData();
    },
    methods : {
        addItem(target){
            const result = new Object();
            result.validita = 1;
            result[target.primary_key] = -1;
            for(let i=0; i < target.headers.length; i++){
                const header = target.headers[i];
                if(header.text != null){ result[header.value] = null; }                
            }
            target.items.push(result);
        },
        getTargetItems(target_name){
            for(let i=0; i<this.targets.length; i++){
                const target = this.targets[i];
                if(target.field_name == target_name){                     
                    const result = new Array();
                    for(let i=0; i <target.items.length; i++){
                        const item = target.items[i];
                        if(Number(item[target.primary_key]) > 0){
                            result.push(item);
                        }
                    } 
                    return result;   
                }
            }
            return null;
        },
        getGeneralData(targets = null) {
            if(targets == null){targets = this.targets; }            
            const request = {
                controller: 'quickconnext',
                endpoint : 'connext',
                response: { parse: false },
                    body: {
                        action: targets.length == 1 ? targets[0].action.replaceAll('__', 'get') : 'getgeneraldata',
                        token: localStorage.user_token,
                },
                method: 'POST',
                on: {
                    load: function (response) {
                        const src = JSON.parse(response);
                        for(let i = 0; i < targets.length; i++){
                            targets[i].items = src[targets[i].field_name];
                        }
                    },
                },
            };
            this.NETWORK.AjaxRequest(request);
        },
        setGeneralData(target){
            const discarded = new Array();
            for(let i=0; i < target.items.length; i++){
                const item = target.items[i];
                if(item.validita != 1 && item[target.primary_key] == -1){
                    discarded.push(i);
                }
            }
            for(let i=0; i < discarded.length; i++){ target.items.splice(discarded[i], 1); }
            const that = this;
            const request = {
                controller: 'quickconnext',
                endpoint : 'connext',
                response: { parse: false },
                    body: {
                    action: target.action.replaceAll('__', 'set'),
                    token: localStorage.user_token,
                    data : target.items
                },
                method: 'PUT',
                on: {
                    load: function () { that.getGeneralData([target]); },
                },
            };
            this.NETWORK.AjaxRequest(request);
        }
    }
}
</script>